module.exports = __webpack_public_path__ + "img/transport_WalkingBooking.e3b1987.png";